import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToolbarType } from '../../../services/lineup-service';

@Component({
  selector: 'toolbar-main',
  templateUrl: 'toolbar-main.html'
})
export class ToolbarMainComponent {
  @Output() onClick = new EventEmitter<ToolbarType>();
  @Output() onSelect = new EventEmitter();
  
  @Input() items: any = [];
  @Input() disabled: boolean = true;
  @Input() team: string;


  activeItem = 0;

  onItemSelect(event){
    console.log('event: ', event);
    let index = this.items.findIndex((x) => x.id == event.id);
    this.onSelect.emit(index);
  }
  // onSettingsClick() {
  //   this.onSettings.emit();
  // }

  public get toolbar(): typeof ToolbarType {
    return ToolbarType;
  }
}





// WEBPACK FOOTER //
// /src/pages/apps/lineup/components/toolbar/toolbar-main/toolbar-main.ts